import React from "react";
import {useIntl} from "react-intl";
import './EventSheetTemplateForm.scss'
import Button from "../../../../components/elements/Button/Button";
import EventSheetDraggableFields from "./DraggableFields/EventSheetDraggableFields";

export default function SectionsList({sections, setSections, sectionOptions, context}) {

    const intl = useIntl();
    const moveSection = (key, direction) => {
        const sectionKeys = Object.keys(sections)
            .sort((a, b) => sections[a].order - sections[b].order);

        const index = sectionKeys.indexOf(key);
        if (index < 0) return;

        let newSections = { ...sections };

        if (direction === "up" && index > 0) {
            const prevKey = sectionKeys[index - 1];
            const currentOrder = newSections[key].order;
            newSections[key].order = newSections[prevKey].order;
            newSections[prevKey].order = currentOrder;
        }

        if (direction === "down" && index < sectionKeys.length - 1) {
            const nextKey = sectionKeys[index + 1];
            const currentOrder = newSections[key].order;
            newSections[key].order = newSections[nextKey].order;
            newSections[nextKey].order = currentOrder;
        }

        setSections(newSections);
        context.setContentUpdated(true);
    };

    return (<>
            {Object.keys(sections)
                .sort((a, b) => (sections[a].order || 0) - (sections[b].order || 0))
                .map((key, i) => (
                    <div key={i}>
                        {/* Nume secțiune (nu editabil) */}
                        <h4 className={"d-flex"} style={{alignItems: "center"}}>
                            {i + 1}.{intl.formatMessage({id: "events.sheet." + key})}
                            { i!==0 && <Button className={"btn-edit btn-light ms-auto"}
                                               icon={"fa-solid fa-arrow-up"}
                                               tooltip={intl.formatMessage({id: 'general.move_up'})}
                                               type="button"
                                     onClick={() => moveSection(key, "up")}/>}
                            {i !== Object.keys(sections).length - 1 && <Button
                                className={"btn-edit btn-light " + (i===0 && "ms-auto")}
                                tooltip={intl.formatMessage({id: 'general.move_down'})}
                                icon={"fa-solid fa-arrow-down"}
                                type="button"
                                     onClick={() => moveSection(key, "down")}/>}
                        </h4>

                        {/* Lista de câmpuri */}
                        <EventSheetDraggableFields sectionKey={key} sections={sections} context={context}
                                             setSections={setSections} sectionOptions={sectionOptions}/>
                    </div>

                ))}
        </>)
        ;
}
